module.exports = __webpack_public_path__ + "img/personal-roboport-mk2-equipment.0ad18ff3.png";